class Injecter {
  static injectBodyScript({ url, body, async, type = "text/javascript", tag }) {
    if (!window || !window.document) {
      throw new Error(
        "Injecter.injectBodyScript: window or window.document is not defined"
      );
    }

    if (tag && document.querySelector(`script[data-tag="${tag}"]`)) {
      return;
    }

    const script = document.createElement("script");

    if (url) {
      script.src = url;
    }
    if (async) {
      script.async = true;
    }
    if (body) {
      script.innerHTML = body;
    }
    if (type) {
      script.type = "text/javascript";
    }
    if (tag) {
      script.setAttribute("data-tag", tag);
    }

    document.body.appendChild(script);
  }
}

export default Injecter;
